import { takeLatest, all, put } from 'redux-saga/effects';
import Actions from "../action";
import { doGet, doPost } from '../../service/index';
import END_POINTS from './EndPoints';
import { STUDENT_REPORT } from '../action/StudentReportAction';

export function* studentReportListSaga({ params, callback }) {
    try {
        const response = yield doGet(END_POINTS.STUDENT_REPORT_API, params)
        yield put(Actions.studentReportSuccessAction(response));
        if (callback) {
            callback(response)
        }
    } catch (error) {
        yield put(Actions.studentReportFailureAction({ error }));
        if (callback) {
            callback(error)
        }
    }
}



export default function* studentReportListWatcher() {
    yield all([
        takeLatest(STUDENT_REPORT, studentReportListSaga),

    ]);
}